<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordocas/svgCas29bg.svg" />
    <div
      class="pageElement text-box-a hover-animation-a"
      id="textBox01"
      style="background-image: url(/pages/img/sordo/svgPage78Textbox01.svg)"
    >
      <p class="textBase pageElement" id="textBox01Text">
        Escribe el título<br />
        que señalaste en<br />
        la tapa del libro.
      </p>
    </div>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />

    <div id="tag01" class="tag" style="z-index: 3; top: 50px" ref="tg1">
      <p class="textBase pageElement tagText">EL PALACIO ENCANTADO</p>
    </div>
    <div id="tag02" class="tag" style="z-index: 3; top: 110px" ref="tg2">
      <p class="textBase pageElement tagText">EL CASTILLO EMBRUJADO</p>
    </div>
    <div id="tag03" class="tag" style="z-index: 3; top: 170px" ref="tg3">
      <p class="textBase pageElement tagText">EL CASTILLO ENCANTADO</p>
    </div>
    <div id="tag04" class="tag" style="z-index: 3; top: 230px" ref="tg4">
      <p class="textBase pageElement tagText">EL CASTILLO DE CHOCOLATE</p>
    </div>

    <p id="bottomText01" class="textBase pageElement">Editorial Astor</p>
    <p id="bottomText02" class="textBase pageElement">
      *Esta portada ha sido creada para esta actividad
    </p>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <span class="footer-page footer-write"></span>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 48px;
  top: 142px;
}
#textBox01 {
  position: absolute;
  width: 363px;
  height: 313.35px;
  left: 616px;
  top: 402px;
}
#textBox01Text {
  position: absolute;
  width: 296px;
  height: 151px;
  left: 44px;
  top: 45px;
  font-size: 36px;
  line-height: 49px;
  color: #fbf8f8;
}
.tag {
  position: absolute;
  width: 520px;
  height: 70.55px;
  left: 550px;
  background-image: url(/pages/img/sordo/svgPage71TagLong.svg);
  background-size: cover;
  transform: scale(0.8);
  transition: 0.3s;
}
.tag:hover {
  transform: translateY(-10px) scale(0.9);
}
#inputField01 {
  position: absolute;
  width: 327px;
  left: 163px;
  top: 228px;
}
#bottomText01 {
  position: absolute;
  left: 438px;
  top: 675px;
  font-family: "Times New Roman", Times, serif;
  font-size: 24px;
  z-index: 3;
}
#bottomText02 {
  position: absolute;
  left: 282px;
  top: 718px;
  font-size: 14px;
  z-index: 3;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 105.mp4",
        "cas/Video 106.mp4",
        "cas/Video 107.mp4",
        "cas/Video 108.mp4",
        "cas/Video 109.mp4",
      ],
    };
  },
};
</script>